import React, { Fragment, useEffect, useState } from 'react';
import { useAsync } from 'react-async';
import { useHistory, useLocation } from 'react-router-dom';
import { addNewStudentToCaseload } from '../../api/services/caseloadService';
import { getSchoolsByDistrict } from '../../api/services/schoolService';
import { getTherapistDistricts } from '../../api/services/districtService';
import { getGenders } from '../../api/services/genderService';
import { getGrades } from '../../api/services/gradeService';
import { getFrequencies } from '../../api/services/frequencyService';
import { getStudentStatuses } from '../../api/services/studentStatusService';
import { getCaseloadTreatmentOptionsByDisciplineId } from '../../api/services/treatmentService';
import { ResponseStatus } from '../../components/notifications';
import { FieldInput } from '../../components/fieldInput';
import Layout from '../../components/layout';
import SubmitButton from '../../components/submitButton';
import LayoutError from '../../components/layoutError';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import TreatmentPlan from '../../api/models/treatmentPlan';
import { getTherapistRoles } from '../../api/services/therapistRolesService';
import User from '../../api/models/user';
import { getCurrentUser } from '../../api/services/meService';
import DistrictsResponse from '../../api/responses/districtsResponse';
import District from '../../api/models/district';
import { getDivisionPlacements } from '../../api/services/placementService';
import { getDivisionEsys } from '../../api/services/esyService';
import School from '../../api/models/school';
import SchoolsResponse from '../../api/responses/schoolsResponse';
import State from '../../api/models/state';
import { getStates } from '../../api/services/stateService';
import { getHomeDistrictOptionsByStateId, getHomeDistricts } from '../../api/services/homeDistrictService';
import Select, { SingleValue } from 'react-select';
import { TreatmentPlanLookup } from '../../common/constants';
import DisciplineGroupRule from '../../api/models/disciplineGroupRule';
import { getCaseloadTreatmentRulesByDisciplineId } from '../../api/services/treatmentRulesService';
import CustomAlert from '../../components/alert/commonAlert';

type svals = { value?: number, label: string }
export type onchange = {
  selections: any
}


type ViewState = {
  dob: Date;
  disciplineId: number;
  approved: boolean;
  studentFirstName: string;
  studentLastName: string;
  searchMatched: boolean;
};

type option = { label: string; value: number; };

const fetchDistricts = async ({ id }: any) => {
  return await getTherapistDistricts(new Date().getMonth() + 1, new Date().getFullYear(), id);
};

const fetchGrades = async () => {
  return await getGrades();
};

const fetchFrequencies = async () => {
  return await getFrequencies();
};

const fetchGenders = async () => {
  return await getGenders();
};

const fetchTherapistRoles = async () => {
  return await getTherapistRoles();
};
const fetchStatuses = async () => {
  return await getStudentStatuses();
};

const fetchPlacement = async (args: any[]) => {
  return await getDivisionPlacements(args[0]);
};

const fetchEsys = async (args: any[]) => {
  return await getDivisionEsys(args[0]);
};

const fetchTreatment = async ({ disciplineId }: any) => {
  return await getCaseloadTreatmentOptionsByDisciplineId(disciplineId);
};

const fetchTreatmentRules = async ({ disciplineId }: any) => {
  return await getCaseloadTreatmentRulesByDisciplineId(disciplineId);
}

const fetchStates = async () => await getStates();
const fetchHomeDistricts = async () => await getHomeDistricts();
const fetchHomeDistrictOptionsByStateId = async (args: any[]) => await getHomeDistrictOptionsByStateId(Number(args && args.length > 0 ? args[0] : 0));

const CreateStudent = () => {
  const history = useHistory();
  const { state } = useLocation<ViewState>();
  const disciplineId = state.disciplineId;
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [mi, setMi] = useState('');
  const [suffix, setSuffix] = useState('');
  const [dobDate, setDobDate] = useState<Date>();
  const [grade, setGrade] = useState<number | undefined>(0);
  const [gender, setGender] = useState<number | undefined>(0);
  const [therapistType, setTherapistType] = useState<number | undefined>(0);
  const [school, setSchool] = useState<number>(0);
  const [district, setDistrict] = useState<number | undefined>(0);
  const [homeDistrict, setHomeDistrict] = useState<number | undefined>(0);
  const [caseloadStartDate, setCaseloadStartDate] = useState<Date>();
  const [caseloadEndDate, setCaseloadEndDate] = useState<Date>();
  const [schoolStartDate, setSchoolStartDate] = useState<Date>();
  const [billingStartDate, setBillingStartDate] = useState<Date>();
  const [studentStatus, setStudentStatus] = useState<number>(0);
  const [treatment, setTreatment] = useState<number | undefined>(0);
  const [treatmentPlans] = useState<TreatmentPlan[]>([]);
  const [iepStartDate, setIepStartDate] = useState<Date>();
  const [group, setGroup] = useState(false);
  const [individual, setIndividual] = useState(false);
  const [consult, setConsult] = useState(false);
  const [individualFrequency, setIndividualFrequency] = useState<number | undefined>(0);
  const [consultFrequency, setConsultFrequency] = useState<number | undefined>(0);
  const [groupFrequency, setGroupFrequency] = useState<number | undefined>(0);
  const [individualMinutes, setIndividualMinutes] = useState<number | undefined>(0);
  const [consultMinutes, setConsultMinutes] = useState<number | undefined>(0);
  const [groupMinutes, setGroupMinutes] = useState<number | undefined>(0);
  const [onIEP, setOnIEP] = useState<boolean>(false);
  const [currentUser, setCurrentUser] = useState<User>();
  const [districtsList, setDistrictsList] = useState<District[]>([]);
  const [placement, setPlacement] = useState<number | undefined>(0);
  const [esy, setEsy] = useState<number | undefined>(0);
  const [schools, setSchools] = useState<School[]>([]);
  const [states, setStates] = useState<State[]>();
  const [homeDistrictState, setHomeDistrictState] = useState<number>();
  const [homeDistricts, setHomeDistricts] = useState<option[]>();
  const [homeDistrictOption, setHomeDistrictOption] = useState<option>();
  const [treatmentRules, setTreatmentRules] = useState<DisciplineGroupRule[]>([])
  const [showTreatmentPlans, setShowTreatmentPlans] = useState<boolean>(false);
  const [treatmentDatesRequired, setTreatmentDatesRequired] = useState<boolean>(false);

  const [showAlert, setShowAlert] = useState<boolean>(false);

  const studentCaseloadStatus = 3;
  const treatmentIEP = 1;
  const treatment504 = 2;

  //Set the student name based on the previous search
  useEffect(() => {
    setFirstName(state.studentFirstName ?? '');
    setLastName(state.studentLastName ?? '');
    setDobDate(state.dob ?? undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const esyData = useAsync({ deferFn: fetchEsys });
  const placementData = useAsync({ deferFn: fetchPlacement });

  useEffect(() => {
    if (!currentUser) {
      //Get current user
      const fetchUser = async () => {
        const userResponse = await getCurrentUser();

        //Get the user information
        const user: User = userResponse.data;

        //Set the current user hook
        setCurrentUser(user);

        if (districtsList.length === 0) {
          getTherapistDistricts(new Date().getMonth() + 1, new Date().getFullYear(), user.userId)
            .then((districts: DistrictsResponse) => setDistrictsList(districts.data.districts));
        }
      }

      fetchUser();
    }
  }, []);

  useEffect(() => {
    var sch = schools.find(x => x.schoolId === school);

    if (sch !== undefined) {
      var div = sch.district.division.divisionId;
      esyData.run(div);
      placementData.run(div);
    }
  }, [school]);

  const studentStatusData = useAsync({
    promiseFn: fetchStatuses,
  });

  const statesData = useAsync({
    promiseFn: fetchStates,
    onResolve: (r) => {
      setStates(r.data?.states ?? []);
      setHomeDistrictState(40);
    }
  });
  const homeDistrictsByStateIdAsync = useAsync({
    deferFn: fetchHomeDistrictOptionsByStateId,
    onResolve: (r) => setHomeDistricts(r?.data ?? [])
  });

  const districtsData = useAsync({
    promiseFn: fetchDistricts,
  });

  const gradesData = useAsync({
    promiseFn: fetchGrades,
  });

  const frequenciesData = useAsync({
    promiseFn: fetchFrequencies,
  });

  const gendersData = useAsync({
    promiseFn: fetchGenders,
  });

  const therapistRolesData = useAsync({
    promiseFn: fetchTherapistRoles,
  });

  const treatmentData = useAsync({
    promiseFn: fetchTreatment, disciplineId
  });

  const treatmentRulesData = useAsync({
    promiseFn: fetchTreatmentRules, disciplineId,
    onResolve: (r) => {
      setTreatmentRules(r.data.rules);
    }
  })

  const schoolsData = useAsync({
    deferFn: (args) => getSchoolsByDistrict(args[0]),
    onResolve: (r: SchoolsResponse) => {
      if (r?.data?.schools && r.data.schools.length > 0) {
        setSchools(r.data?.schools);

        // if (!r.data.schools.find(x => x.schoolId == school)) {
        //   setSchool(r.data.schools[0].schoolId ?? school);
        // }
      }
    }
  });

  const saveStudent = async () => {
    let treatmentPlansTemp: TreatmentPlan[] = [];
    if (individual) {
      treatmentPlansTemp.push({
        treatmentPlanId: 0,
        treatmentPlanTypeId: TreatmentPlanLookup.Individual,
        treatmentFrequencyId: individualFrequency,
        treatmentPlanDuration: individualMinutes,
      })
    }

    if (group) {
      treatmentPlansTemp.push({
        treatmentPlanId: 0,
        treatmentPlanTypeId: TreatmentPlanLookup.Group,
        treatmentFrequencyId: groupFrequency,
        treatmentPlanDuration: groupMinutes,
      })
    }

    if (consult) {
      treatmentPlansTemp.push({
        treatmentPlanId: 0,
        treatmentPlanTypeId: TreatmentPlanLookup.Consult,
        treatmentFrequencyId: consultFrequency,
        treatmentPlanDuration: consultMinutes,
      })
    }

    return await addNewStudentToCaseload({
      disciplineId: state.disciplineId,
      schoolId: school,
      placement: placement,
      esy: esy,
      firstName: firstName,
      lastName: lastName,
      mi: mi,
      suffix: suffix,
      dob: dobDate?.toLocaleDateString(),
      gradeId: grade,
      genderId: gender,
      TherapistRoleId: therapistType,
      isApproved: state.approved,
      caseloadStartDate: caseloadStartDate?.toLocaleDateString(),
      caseloadEndDate: caseloadEndDate?.toLocaleDateString(),
      schoolStartDate: schoolStartDate?.toLocaleDateString(),
      studentStatusId: studentStatus,
      homeDistrictId: homeDistrict,
      treatmentId: treatment,
      iepStartDate: iepStartDate?.toLocaleDateString(),
      iepEndDate: moment(iepStartDate).add(1, 'year').subtract(1, 'day').toDate()?.toLocaleDateString(),
      billingStartDate: billingStartDate?.toLocaleDateString(),
      treatmentPlans: treatmentPlansTemp
    });
  };



  let treatmentvals: svals[] = [];
  (treatmentData.data?.data.treatments.map((g) => (
    treatmentvals.push({ value: g.treatmentId, label: g.name })
  )));
  treatmentvals.sort((a, b) => a.label.localeCompare(b.label));
  //let treatmentSelects: [] = [];

  const save = useAsync({
    deferFn: saveStudent,
    onResolve: (r) => {
      const message = `${firstName} ${lastName} ${state.approved ? 'added successfully!' : 'requested for approval'}`;

      //State parameters
      let stateParams: any = { message: message };
      if (state.disciplineId && state.disciplineId !== 0) stateParams.disciplineId = state.disciplineId;

      history.push(`/caseload`, stateParams);
    },
  });
  useEffect(() => homeDistrictsByStateIdAsync.run(homeDistrictState), [homeDistrictState]);
  const handleHomeDistrictChange = (e: SingleValue<option>) => {
    if (e) {
      setHomeDistrict(Number(e.value));
      setHomeDistrictOption(e ?? { label: '', value: '' });
    }
  };
  const handleHomeDistrictStateChange = (e: React.FormEvent<HTMLSelectElement>) => setHomeDistrictState(Number(e.currentTarget.value));

  const handleDistrictChange = (districtId: number) => {
    setDistrict(districtId);
    setHomeDistrict(districtId);

    if (!Number.isNaN(districtId) && districtId > 0) {
      schoolsData.run(districtId);
    }
    else{
      setSchools([]);
    }
  };

  const handleTreatmentChanged = (treatmentId: number) => {
    setTreatment(treatmentId)
    let rules = treatmentRules?.find(x => x.treatmentId === treatmentId);
    let showPlans = rules?.isPlanRequired ?? false;
    let datesRequired = rules?.isDatesRequired ?? false;
    setShowTreatmentPlans(showPlans);
    if (!showPlans) {
      setIndividual(showPlans);
      setIndividualFrequency(0);
      setIndividualMinutes(0);

      setGroup(showPlans);
      setGroupFrequency(0);
      setGroupMinutes(0);

      setConsult(showPlans);
      setConsultFrequency(0);
      setConsultMinutes(0);
    }

    setTreatmentDatesRequired(datesRequired);
  }

  const handleProceed = async (): Promise<void> => {
    try {
      save.run()
      setShowAlert(false); // Close alert after success

      // Continue with additional logic (e.g., success message, state updates)
    } catch (error) {
      console.error('Error in Proceed action:', error);
    }
  };

  const handleCancel = async (): Promise<void> => {
    try {
      setShowAlert(false); // Close alert after cancel
    } catch (error) {
      console.error('Error in Cancel action:', error);
    }
  };

  // Error handling
  if (districtsData.error || gradesData.error || gendersData.error)
    return <LayoutError />;

  return (
    <Layout
      isLoading={
        districtsData.isPending ||
        gendersData.isPending ||
        gradesData.isPending ||
        schoolsData.isPending ||
        statesData.isPending ||
        //homeDistrictsData.isPending ||
        homeDistrictsByStateIdAsync.isPending
      }
    >
      <Fragment>
        <ResponseStatus state={save} />
        <div className='grid grid-cols-6 gap-6 mb-6'>
          <div className='col-span-6 sm:col-span-6 lg:col-span-2'>
            <FieldInput
              name='firstName'
              label='First Name'
              minLength={1}
              onChange={(e) => setFirstName(e.target.value)}
              value={firstName}
            />
          </div>
          <div className='col-span-6 sm:col-span-6 lg:col-span-1'>
            <FieldInput
              name='mi'
              label='MI'
              onChange={(e) => setMi(e.target.value)}
              value={mi}
            />
          </div>
          <div className='col-span-6 sm:col-span-6 lg:col-span-2'>
            <FieldInput
              name='lastName'
              label='Last Name'
              minLength={1}
              onChange={(e) => setLastName(e.target.value)}
              value={lastName}
            />
          </div>
          <div className='col-span-6 sm:col-span-6 lg:col-span-1'>
            <FieldInput
              name='suffix'
              label='Suffix'
              onChange={(e) => setSuffix(e.target.value)}
              value={suffix}
            />
          </div>
          <div className='col-span-6 sm:col-span-6 lg:col-span-1'>
            <label className='primary'>
              Date Of Birth <span className='pl-1 text-red-500'>*</span>
            </label>
            <DatePicker
              className='block mt-1 primary'
              selected={dobDate}
              onChange={(date: Date) => setDobDate(date!)}

              maxDate={new Date()}
            />
          </div>
          <div className='col-span-6 sm:col-span-6 lg:col-span-1'>
            <label className='primary'>
              Grade<span className='pl-1 text-red-500'>*</span>
            </label>
            <select
              onChange={(e) => setGrade(Number(e.target.value))}
              className='block mt-1 primary'
              value={grade}
            >
              <option value='0'> -- Choose Grade --</option>
              {gradesData.data?.data.grades.map((g, i) => (
                <option key={`grade-${i}`} value={g.gradeId}>{g.name}</option>
              ))}
            </select>
          </div>
          <div className='col-span-6 sm:col-span-6 lg:col-span-2'>
            <label className='primary'>
              Gender<span className='pl-1 text-red-500'>*</span>
            </label>
            <select
              onChange={(e) => setGender(Number(e.target.value))}
              className='block mt-1 primary'
              value={gender}
            >
              <option value='0'> -- Choose Gender --</option>
              {gendersData.data?.data.genders.sort((a, b) => {
                return a.name.localeCompare(b.name);
              }).map((g, i) => (
                <option key={`gender-${i}`} value={g.genderId}>{g.name}</option>
              ))}
            </select>
          </div>
          <div className='col-span-6 sm:col-span-6 lg:col-span-2'>
            <label className='primary'>
              Therapist Type<span className='pl-1 text-red-500'>*</span>
            </label>
            <select
              onChange={(e) => setTherapistType(Number(e.target.value))}
              className='block mt-1 primary'
              value={therapistType}
            >
              <option value='0'> -- Choose Therapist Type --</option>
              {therapistRolesData.data?.data.therapistRoles.sort((a, b) => {
                return a.name.localeCompare(b.name);
              }).map((g, i) => (
                <option key={`role-${i}`} value={g.therapistRoleId}>{g.name}</option>
              ))}
            </select>
          </div>
          <div className='col-span-6 sm:col-span-6 lg:col-span-2'>
            <label className='primary'>
              District<span className='ml-1 text-red-500'>*</span>
            </label>
            <select
                onChange={(e) => {
                  handleDistrictChange(Number(e.target.value));
                }}
              className='block mt-1 primary'
              value={district}
            >
              <option value='0'> -- Choose District --</option>
              {districtsList
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((s, i) => (
                  <option key={`district-${i}`} value={s.districtId}>{s.name}</option>
                ))}
            </select>
          </div>

          <div className='col-span-6 sm:col-span-6 lg:col-span-1'>
            <label className='primary'>
              Home District State<span className='ml-1 text-red-500'>*</span>
            </label>
            <select
              onChange={handleHomeDistrictStateChange}
              className='block mt-1 primary'
              value={homeDistrictState}
            >
              <option value='0'> -- Choose State --</option>
              {states && states
                //.sort((a, b) => a.name.localeCompare(b.name))
                .map((s, i) => (
                  <option key={`home-district-state-${s.stateId}`} value={s.stateId}>{s.name}</option>
                ))}
            </select>
          </div>

          <div className='col-span-6 sm:col-span-6 lg:col-span-3'>
            <label className='primary'>
              Home District<span className='ml-1 text-red-500'>*</span>
            </label>
            <Select
              onChange={(e) => handleHomeDistrictChange(e)}
              className='block mt-1 primary'
              value={homeDistrictOption}
              options={homeDistricts ?? []}
              placeholder={`Select Home District...`}
              isSearchable
            />
          </div>

         
              <div className='col-span-6 sm:col-span-6 lg:col-span-3'>
                <label className='primary'>
                  School<span className='ml-1 text-red-500'>*</span>
                </label>
                <select
                  onChange={(e) => setSchool(Number(e.target.value))}
                  className='block mt-1 primary'
                  value={school}
                //value={moment(districtsList.find(x => x.districtId === district)?.esyStartDate).isValid() && moment(districtsList.find(x => x.districtId === district)?.esyStartDate).isSameOrBefore(new Date()) ? schools.find(x => x.internal)?.schoolId ?? (school === 0 || school === districtsList.find(x => x.districtId === district)?.esySchoolId || !schools.find(x => x.schoolId === school) ? schools.find(x => x)?.schoolId : school) : (school === 0 || school === districtsList.find(x => x.districtId === district)?.esySchoolId || !schools.find(x => x.schoolId === school) ? schools.find(x => x)?.schoolId : school)}
                //disabled={moment(districtsList.find(x => x.districtId === district)?.esyStartDate).isValid() && moment(districtsList.find(x => x.districtId === district)?.esyStartDate).isSameOrBefore(new Date())}
                >
                  {schools && schools.length > 0 &&
                    <>
                      <option value='0'> -- Choose School --</option>
                      {schools
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((s, i) => (
                          <option key={`school-${i}`} value={s.schoolId}>{s.name}</option>
                        ))}
                    </>
                  }

                  {!schools || schools.length === 0 &&
                    <option value='0'> -- No Schools Found --</option>
                  }
                </select>
              </div>
              <div className='col-span-6 sm:col-span-6 lg:col-span-3'>
              <label className='primary'>School Start Date<span className='ml-1 text-red-500'>*</span></label>
                <DatePicker
                  className='block mt-1 primary'
                  selected={schoolStartDate}
                  onChange={(date: Date) => setSchoolStartDate(date!)}
                />
              </div>
       
          <div className='col-span-6 sm:col-span-6 lg:col-span-3'>
            <label className='primary'>
              Placement <span className='pl-1 text-red-500'>*</span></label>
            <select
              onChange={(e) => setPlacement(Number(e.target.value))}
              className='block mt-1 primary'
              value={placement}
            >
              <option value='0'> -- Select --</option>
              {placementData.data?.data.placements.sort((a, b) => a.name.localeCompare(b.name)).map((g) => (
                <option
                  key={`placement-${g.placementId}`}
                  value={g.placementId}>{g.name}</option>
              ))}
            </select>
          </div>
          <div className='col-span-6 sm:col-span-6 lg:col-span-3'>
            <label className='primary'>
              ESY Eligible <span className='pl-1 text-red-500'>*</span></label>
            <select
              onChange={(e) => setEsy(Number(e.target.value))}
              className='block mt-1 primary'
              value={esy}
            >
              <option value='0'> -- Select --</option>
              {esyData.data?.data.esys.sort((a, b) => a.name.localeCompare(b.name)).map((g) => (
                <option
                  key={`placement-${g.esyId}`}
                  value={g.esyId}>{g.name}</option>
              ))}
            </select>
          </div>
          <div className='col-span-6 sm:col-span-6 lg:col-span-3'>
            <label className='primary'>
              Student Status<span className='pl-1 text-red-500'>*</span>
            </label>
            <select
              onChange={(e) => setStudentStatus(Number(e.target.value))}
              className='block mt-1 primary'
              value={studentStatus}
            >
              <option value='0'> -- Choose Status --</option>
              {studentStatusData.data?.data.studentStatuses.sort((a, b) => a.name.localeCompare(b.name)).map((s, i) => (
                <option key={`status-${i}`} value={s.studentStatusId}>{s.name}</option>
              ))}
            </select>
          </div>
          <div className='col-span-6 sm:col-span-6 lg:col-span-1'>
            <label className='primary'>
              Caseload Start Date<span className='pl-1 text-red-500'>*</span>
            </label>
            <DatePicker
              className='block mt-1 primary'
              selected={caseloadStartDate}
              onChange={(date: Date) => setCaseloadStartDate(date!)}
            />
          </div>
          <div className='col-span-6 sm:col-span-6 lg:col-span-1'>
            <label className='primary'>Caseload End Date</label>
            <DatePicker
              className='block mt-1 primary'
              selected={caseloadEndDate}
              onChange={(date: Date) => setCaseloadEndDate(date!)}
            />
          </div>
          <div className='col-span-6 sm:col-span-6 lg:col-span-1'>
            <label className='primary'>Billing Start Date<span className='pl-1 text-red-500'>*</span></label>
            <DatePicker
              className='block mt-1 primary'
              selected={billingStartDate}
              onChange={(date: Date) => setBillingStartDate(date!)}
            />
          </div>
          {studentStatus === studentCaseloadStatus && (
            <Fragment>
              {/*               <div className='col-span-6 sm:col-span-6 lg:col-span-2'>
                <label className='primary'>
                  Treatment Via<span className='pl-1 text-red-500'>*</span>
                </label>
                <select
                  onChange={(e) => setTreatment(Number(e.target.value))}
                  className='block mt-1 primary'
                  value={treatment}
                >
                  <option value='0'> -- Treatment Via--</option>
                  {treatmentData.data?.data.treatments.sort((a, b) => a.name.localeCompare(b.name)).map((g) => (
                    <option value={g.treatmentId}>{g.name}</option>
                  ))}
                </select>
              </div> */}
              <div className='col-span-6 sm:col-span-6 lg:col-span-2'>
                <label className='primary'>
                  Treatment Via<span className='pl-1 text-red-500'>*</span>
                </label>
                <select
                  className='block border-gray-300 rounded-md shadow-sm'
                  value={treatment}
                  onChange={(e) => handleTreatmentChanged(Number(e.target.value))}
                >
                  {treatmentvals.map((treatment) => (
                    <option key={treatment.value} value={treatment.value}>
                      {treatment.label}
                    </option>
                  ))}
                </select>
              </div>


            </Fragment>
          )}
          {studentStatus === studentCaseloadStatus && (
            <div className='col-span-6 sm:col-span-6 lg:col-span-2'>
              <label className='primary'>
                Treatment Start Date{treatmentDatesRequired && <span className='pl-1 text-red-500'>*</span>}
              </label>
              <DatePicker
                className='block mt-1 primary'
                selected={iepStartDate}
                required={treatmentDatesRequired}
                onChange={(date: Date) => setIepStartDate(date!)}
              />
            </div>
          )}
          {studentStatus === studentCaseloadStatus &&
            iepStartDate !== null &&
            iepStartDate !== undefined && (
              <div className='col-span-6 sm:col-span-6 lg:col-span-1'>
                <label className='primary'>Treatment End Date</label>
                <p>
                  {iepStartDate !== undefined ? moment(iepStartDate).add(1, 'year').subtract(1, 'day').format('l') : ''}
                </p>
              </div>
            )}
          {studentStatus === studentCaseloadStatus && showTreatmentPlans && (
            <Fragment>
              <div className='col-span-6 sm:col-span-6'>
                <h1 className='mb-3'>Treatment Plan</h1>

                <div className='flex items-start'>
                  <div className='flex items-center h-5'>
                    <input
                      id='individual'
                      name='individual'
                      type='checkbox'
                      checked={individual}
                      onChange={(e) => setIndividual(e.currentTarget.checked)}
                    />
                  </div>
                  <div className='ml-3 text-sm'>
                    <label htmlFor='individual'>Individual</label>
                  </div>
                </div>
              </div>
              {individual && (
                <Fragment>
                  <div className='col-span-6 ml-6 sm:col-span-6 lg:col-span-2'>
                    <label className='primary'>Frequency</label>
                    <select
                      onChange={(e) => setIndividualFrequency(Number(e.target.value))}
                      className='block mt-1 primary'
                      value={individualFrequency}
                    >
                      <option value='0'> -- Frequency--</option>
                      {frequenciesData.data?.data.frequencies.sort((a, b) => a.loadOrder - b.loadOrder).map((g, i) => (
                        <option key={`treatment-frequency-individual-${i}`} value={g.treatmentFrequencyId}>{g.treatmentFrequencyName}</option>
                      ))}
                    </select>
                  </div>


                  <div className='col-span-6 ml-6 sm:col-span-6 lg:col-span-2'>
                    <FieldInput
                      name='individualMinutes'
                      label='Minutes'
                      onChange={(e) => setIndividualMinutes(Number(e.target.value.replace(/\D/g, "")))}
                      value={individualMinutes ? individualMinutes.toString() : ''}
                    />
                  </div>
                </Fragment>
              )}
              <div className='col-span-6 sm:col-span-6'>
                <div className='flex items-start'>
                  <div className='flex items-center h-5'>
                    <input
                      id='group'
                      name='group'
                      type='checkbox'
                      checked={group}
                      onChange={(e) => setGroup(e.currentTarget.checked)}
                    />
                  </div>
                  <div className='ml-3 text-sm'>
                    <label htmlFor='group'>Group</label>
                  </div>
                </div>
              </div>
              {group && (
                <Fragment>
                  <div className='col-span-6 ml-6 sm:col-span-6 lg:col-span-2'>
                    <label className='primary'>Frequency</label>
                    <select
                      onChange={(e) => setGroupFrequency(Number(e.target.value))}
                      className='block mt-1 primary'
                      value={groupFrequency}
                    >
                      <option value='0'> -- Frequency--</option>
                      {frequenciesData.data?.data.frequencies.sort((a, b) => a.loadOrder - b.loadOrder).map((g, i) => (
                        <option key={`frequency-group-${i}`} value={g.treatmentFrequencyId}>{g.treatmentFrequencyName}</option>
                      ))}
                    </select>
                  </div>
                  <div className='col-span-6 ml-6 sm:col-span-6 lg:col-span-2'>
                    <FieldInput
                      name='groupMinutes'
                      label='Minutes'
                      onChange={(e) => setGroupMinutes(Number(e.target.value.replace(/\D/g, "")))}
                      value={groupMinutes ? groupMinutes.toString() : ''}
                    />
                  </div>
                </Fragment>
              )}
              <div className='col-span-6 sm:col-span-6'>
                <div className='flex items-start'>
                  <div className='flex items-center h-5'>
                    <input
                      id='consult'
                      name='consult'
                      type='checkbox'
                      checked={consult}
                      onChange={(e) => setConsult(e.currentTarget.checked)}
                    />
                  </div>
                  <div className='ml-3 text-sm'>
                    <label htmlFor='consult'>Consult</label>
                  </div>
                </div>
              </div>
              {consult && (
                <Fragment>
                  <div className='col-span-6 ml-6 sm:col-span-6 lg:col-span-2'>
                    <label className='primary'>Frequency</label>
                    <select
                      onChange={(e) => setConsultFrequency(Number(e.target.value))}
                      className='block mt-1 primary'
                      value={consultFrequency}
                    >
                      <option value='0'> -- Frequency--</option>
                      {frequenciesData.data?.data.frequencies.sort((a, b) => a.loadOrder - b.loadOrder).map((g, i) => (
                        <option key={`treatment-frequency-consult-${i}`} value={g.treatmentFrequencyId}>{g.treatmentFrequencyName}</option>
                      ))}
                    </select>
                  </div>
                  <div className='col-span-6 ml-6 sm:col-span-6 lg:col-span-2'>
                    <FieldInput
                      name='consultMinutes'
                      label='Minutes'
                      onChange={(e) => setConsultMinutes(Number(e.target.value.replace(/\D/g, "")))}
                      value={consultMinutes ? consultMinutes.toString() : ''}
                    />
                  </div>
                </Fragment>
              )}
            </Fragment>
          )}
        </div>
        <div className='text-right'>
          <SubmitButton
            text={state.searchMatched ? 'Request Student' : 'Create Student'}
            spinning={save.isPending}
            disabled={
              firstName.length === 0 ||
              lastName.length === 0 ||
              district === 0 ||
              placement === 0 ||
              schoolStartDate === undefined ||
              schoolStartDate === null ||
              esy === 0 ||
              school === 0 ||
              dobDate === undefined ||
              dobDate === null ||
              caseloadStartDate === undefined ||
              caseloadStartDate === null ||
              studentStatus === 0 ||
              gender === 0 ||
              grade === 0 ||
              (!homeDistrict || homeDistrict === 0) ||
              (!homeDistrictState || homeDistrictState === 0) ||
              studentStatus === 0 ||
              therapistType === 0 ||
              (studentStatus === studentCaseloadStatus && ((treatment === treatment504 || onIEP === true) && (iepStartDate === null || iepStartDate === undefined))) ||
              (onIEP === true && !group && !individual && !consult) ||
              (onIEP === true && group && (groupFrequency === 0 || groupMinutes === 0)) ||
              (onIEP === true && individual && (individualFrequency === 0 || individualMinutes === 0)) ||
              (onIEP === true && consult && (consultFrequency === 0 || consultMinutes === 0)) ||
              (billingStartDate === undefined || billingStartDate === null)
            }
            onClick={() => {
              const buttonText = state.searchMatched ? 'Request Student' : 'Create Student';          
              // If the button text is 'Request Student', show the confirmation alert
              if (buttonText === 'Request Student') {
                setShowAlert(true); 
              } else {
                save.run(); // Continue with the save action as usual
            }}}
          />
          
          {/* Render the CustomAlert if showAlert is true */}
          {showAlert && (
            <CustomAlert
              message="A student with the same name already exists in the system. This request will need to be reviewed to make sure a duplicate student is not being created.  Would you like to proceed with requesting this new student?"
              onProceed={handleProceed}
              onCancel={handleCancel}
              showProceedCancel={true} // Show Proceed and Cancel buttons
            />
          )}
        </div>
      </Fragment>
    </Layout >
  );
};

export default CreateStudent;
